import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ContentLibraryForServiceLine from './ContentLibraryForServiceLine';
import ErrorBoundary from '../../ErrorBoundary';

class ContentLibraryServiceLineTabSettings extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;

            var path = window.origin + "/my-jeeva/projectmgmt/service-line-content-library";
            var path1 = window.origin + "/my-jeeva/projectmgmt/service-line-content-library/";
            if (currentPath == path || currentPath == path1) {
                $("#service-line-content-library").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-project-survey-tab")).addClass('active')
            }
            $("#service-line-content-library")
                .on("click", function () {
                    $("#service-line-content-library")
                        .removeClass('active');
                    localStorage.setItem("last-project-about-tab", $(this)[0].id);

                    $(this).addClass('active')

                })



        })();
    }
    goBackFromSubTab = () => {
        this.props.history.push({
            pathname: "/projectmgmt/service-line",
            state: {
                healthSystemId: this.props.location.state.healthSystemId,
                hospitalId: this.props.location.state.hospitalId,
                serviceLineId: this.props.location.state.serviceLineId
            }
        });

    }
    saveVersion() {
        var saveVersionController = this;
        $.ajax({
            url: '/my-jeeva-api/save-version',

            method: 'GET',
            data: {

            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success == true) {
                    console.log('save version');
                }
            }
        })
    }
    publish() {
        var publishController = this;
        $.ajax({
            url: '/my-jeeva-api/publish',

            method: 'GET',
            data: {

            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success == true) {
                    console.log('start publish');
                }
            }
        })
    }
    viewVersion() {
        var viewVersionController = this;
        $.ajax({
            url: '/my-jeeva-api/view-version',

            method: 'GET',
            data: {

            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success == true) {
                    console.log('save version');
                }
            }
        })
    }
    render() {
        return (
            <ErrorBoundary>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        {/* Font Awesome Icons */}
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        {/* IonIcons */}
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        {/* Theme style */}
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className='col-sm-4'>
                                        <img src="assets/images/arrow.svg"
                                            style={{ paddingRight: "30%", cursor: 'pointer' }}
                                            onClick={this.goBackFromSubTab}
                                        />
                                    </div>
                                    <div className="col-sm-4" style={{ marginTop: '-1vw' }}>
                                        <h1 className="m-0 page-title">Content Library of {this.props.location.state.treatmentName}</h1>
                                    </div>
                                    <div className='col-sm-4' Align="right">
                                        <button className="btn action-button"
                                            style={{ marginRight: '-2px' }} onClick={() => this.saveVersion()}
                                        >Save Version</button>
                                        <button className="btn action-button"
                                            style={{ marginRight: '-2px' }} onClick={() => this.publishVersion()}
                                        >Publish</button>
                                        <button className="btn action-button"
                                            style={{ marginRight: '-2px' }} onClick={() => this.viewVersion()}
                                        >View Version</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container-fluid" >

                            <div className="border-bottom"></div>
                            <div className="tab-class">

                                <ul className="nav nav-tabs border-bottom navCluster">

                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/service-line-content-library" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="service-line-content-library" style={{ marginLeft: '1vw' }}>
                                            Library
                                        </li>
                                    </Link>


                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>
                        <Route path="/projectmgmt/service-line-content-library" component={ContentLibraryForServiceLine}></Route>
                    </Switch>
                </div>
            </ErrorBoundary>
        );
    }
}
export default ContentLibraryServiceLineTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ContentLibraryServiceLineTabSettings.js